import(/* webpackMode: "eager" */ "/home/hpbs/frontend/assets/client-1.png");
;
import(/* webpackMode: "eager" */ "/home/hpbs/frontend/assets/client-2.png");
;
import(/* webpackMode: "eager" */ "/home/hpbs/frontend/assets/client-3.png");
;
import(/* webpackMode: "eager" */ "/home/hpbs/frontend/assets/client-4.png");
;
import(/* webpackMode: "eager" */ "/home/hpbs/frontend/assets/client-5.png");
;
import(/* webpackMode: "eager" */ "/home/hpbs/frontend/assets/client-6.png");
;
import(/* webpackMode: "eager" */ "/home/hpbs/frontend/components/containers/HighStandards/index.tsx");
;
import(/* webpackMode: "eager" */ "/home/hpbs/frontend/components/containers/Opportunity/index.tsx");
;
import(/* webpackMode: "eager" */ "/home/hpbs/frontend/components/containers/Specialists/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/hpbs/frontend/node_modules/next-intl/dist/esm/navigation/shared/BaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/hpbs/frontend/node_modules/next-intl/dist/esm/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager" */ "/home/hpbs/frontend/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/home/hpbs/frontend/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/home/hpbs/frontend/node_modules/next/dist/shared/lib/lazy-dynamic/preload-css.js");
